// extracted by mini-css-extract-plugin
export var fullWidthButton = "_rz-0";